import { BehaviorSubject } from 'rxjs';
import { Injectable } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { VideoType } from '../enums/video-type.enum';

@Injectable()
export class VideoService {
  correctVideoLinkSanitizer: SafeResourceUrl = null;
  resultUrl: string;
  videoLoading = new BehaviorSubject<boolean>(false);
  videoLoading$ = this.videoLoading.asObservable();

  constructor(
    private sanitizer: DomSanitizer,
    public toast: ToastrService,
    public translate: TranslateService
  ) {}

  errorCorrectVideoLink(): void {
    this.toast.error(this.translate.instant('PROJECT.not_correct_video'));
    return;
  }

  sanitizeUrl(value: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(value);
  }

  getVideoType(value: string): VideoType {
    const type = Object.values(VideoType).filter((val) => value.search(val) > 0);
    return type[0];
  }

  correctVideoLink(value: string): string {
    let result = null;
    if (value) {
      // break endless loop of executing function if value is correct
      if (
        value.includes('https://player.vimeo.com/video/') ||
        value.includes('https://youtube.com/embed/')
      ) {
        return value;
      }
      // check type of the video - youtube/vimeo/youtube shorts
      const type = this.getVideoType(value);
      if (type) {
        // check if video has a 'startTime' or other params
        this.videoLoading.next(true);
        // get result id
        switch (type) {
          case VideoType.VIMEO:
            result = this.checkVideo(value, '.com/', 'https://player.vimeo.com/video/');
            break;

          case VideoType.YOU_TUBE:
            let split = '.com/watch?v=';

            if (value.includes('/shorts/')) {
              split = '/shorts/';
            }

            result = this.checkVideo(value, split, 'https://youtube.com/embed/');
            break;

          case VideoType.YOU_TUBE_SHORT:
            const youtubeConst = 'https://youtube.com/embed/';
            const videoId = value.slice(value.lastIndexOf('/') + 1);
            result = youtubeConst + videoId;
            break;

          default:
            this.errorCorrectVideoLink();
            return;
        }
      }
      return result;
    }
  }

  checkVideo(value, type, resText): void | string {
    let id = '';
    let result = '';
    const str = value.split(type);
    if (str.length <= 1) {
      this.errorCorrectVideoLink();
    }
    id = str[1].split('?')[0];
    if (id.includes('&')) {
      id = id.split('&')[0];
    }
    result = resText + id;

    return result;
  }
}
